"use client";

import styles from "./NewGamePromoBanner.module.css";
import React, { useContext, useMemo } from "react";
import { useRouter } from "next/navigation";

import { AppContext } from "../../context/AppContext";
import { GameContext } from "../../context/GameContext";

// ako koristiš drugi path, samo prilagodi ../../

type FeaturedGame = {
    gameId: number;
    machineId: number;
    displayName: string;
    created?: string | number | Date;
    categoryIds?: number[];
    cdkSquareImageUrl?: string;
    cdkTallImageUrl?: string;
    gameImageUrl?: string;
    promoImageUrl?: string;
};

export default function NewGamePromoBanner() {
    const { user, setIsClosed, games = [], gamesCategories = [] } = useContext(AppContext);
    const { startGame } = useContext(GameContext);
    const router = useRouter();

    const fallbackNewGame: FeaturedGame = {
        gameId: 18,
        machineId: 477,
        displayName: "Coyote Cash 2",
        gameImageUrl: "/assets/new-game/goat-spins-web-ngr-coyote-instant-withdrawals.png",
    };

    const formatGameSlug = (name: string) =>
        String(name || "")
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/(^-|-$)/g, "");

    const newestGame = useMemo<FeaturedGame | null>(() => {
        const newGamesCategory = gamesCategories.find(
            (category: { path?: string; categoryId?: number }) => category?.path === "new-games"
        );

        const newGamesCategoryId = newGamesCategory?.categoryId;

        const fromNewGames = Array.isArray(games)
            ? (games as FeaturedGame[]).filter((game) =>
                newGamesCategoryId != null
                    ? game?.categoryIds?.includes(newGamesCategoryId)
                    : true
            )
            : [];

        const sortedByCreated = [...fromNewGames].sort(
            (a, b) =>
                new Date(b?.created || 0).getTime() - new Date(a?.created || 0).getTime()
        );

        return sortedByCreated[0] || null;
    }, [games, gamesCategories]);

    const getFeaturedGameImage = (game: FeaturedGame) =>
        game?.cdkSquareImageUrl ||
        game?.promoImageUrl ||
        game?.gameImageUrl ||
        fallbackNewGame.gameImageUrl ||
        "";

    const featuredGame = newestGame || fallbackNewGame;
    const featuredGameSlug = `/${formatGameSlug(featuredGame?.displayName)}`;
    const featuredGameImage = getFeaturedGameImage(featuredGame) || fallbackNewGame.gameImageUrl || "";

    const handleClick = () => {
        if (!user) {
            setIsClosed(false);
            return;
        }

        startGame(
            featuredGame.gameId,
            featuredGame.machineId,
            featuredGame.displayName,
            () => router.push(featuredGameSlug)
        );
    };

    return (
                <div className={styles.ContProBoxes}>
                            <div className={styles.BoxPromosH_S} onClick={handleClick}>
                                <div className={styles.FrontProH_S}>
                                    <p className="seoP3">New Game</p>
                                    <p className="seoP4 Game">{featuredGame.displayName}</p>
                                    <div className={styles.BtnPromo}>Play Now</div>
                                </div>
                                <div className={`${styles.ChPromo} ${styles.Game}`}>
                                    <img
                                        src={featuredGameImage}
                                        className={styles.ImgChPromoGame}
                                        alt={`New Game ${featuredGame.displayName}`}
                                    />
                                </div>
                            </div>
                        </div>
    );
}
